export default __webpack_public_path__ + "static/media/Void.f5b9d8a5.svg";